module.exports = class DealsPageHeaderView
  constructor: (@$dealsMessage, @breadcrumb) ->

  render: ->
    # Browse page XHR already updates H1 title on browse/frontend/helpers/header_title
    if Groupon.collection?.id? and @breadcrumb?.pageTitleLink
      @$el = $('.page-header .title span')
      {text, href} = @breadcrumb.pageTitleLink
      @$el.attr 'href', href
      @$el.text text

    if Groupon.onNoDealsPage
      @$dealsMessage.show()
